module.exports = __webpack_public_path__ + "media/audio9.8cd90381.mp3";